import OImage from "components/reusable/OImage";
import OInputField from "components/reusable/OInputField";
import useToastContext from "hooks/useToastContext";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { apiPut } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import photoClose from "../../assets/images/photo_close.png";
import AuthContext from "context/AuthContext";

const EditProjectStatus = () => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const { config } = useContext(AuthContext);

  const location = useLocation();
  const [item] = useState(location?.state?.item);
  const navigate = useNavigate();
  const [icon, setIcon] = useState([]);

  const {
    register,
    setValue,
    // watch,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const iconRef = useRef()

  const replaceUrl = (data) => {
    let newUrl = data;
    if (typeof data !== "object") {
      const dbUrl = data?.split(config?.country === "Saudi" ? "o/" : "net/");
      newUrl = dbUrl?.[1];
    } else newUrl = data;
    return newUrl;
  };


  
useEffect(() => {
    setValue("name", item?.name);
    setValue("nameAr", item?.nameAr);
    setValue("image", item?.image);
    setIcon(item?.image);
  }, [item]);


  
  const handleSubmitForm = async (data) => {
    let formData = new FormData();
    if(typeof icon === "object"){
      formData.append("image",  icon?.[0]);
    } else formData.append("image", replaceUrl(icon));
    formData.append("name", data?.name);
    formData.append("nameAr", data?.nameAr);
    try {
      const { data: response } = await apiPut(
        `${apiPath.projectStatus}/${item?._id}`,
        formData
      );

      if (response?.success) {
        notification.success(response?.message);
        navigate("/project-status");
      } else {
        notification.error(response?.message);
      }
    } catch (error) {
      notification.error(error?.message);
    }
  };



  const handlePhotosChange = (e) => {
    const files = e.target.files;
    let images = [];
    for (let i = 0; i < files?.length; i++) {
      images.push(files[i]);
    }   
        setIcon(e.target.files);
    }


  return (
    <div className="basic_info px-4 ">
    <form
      className="py-4"
      onSubmit={handleSubmit(handleSubmitForm, (submit) => {})}
    >
      <div className="">
      <div className="grid grid-rows-1 grid-cols-2 gap-4">
          
          <div className="mb-3">
            <label className="block">
              <OInputField
                wrapperClassName="relative z-0   w-full group"
                name="name"
                inputLabel={<>Name</>}
                type="text"
                register={register("name", {
                  required: "Please enter name",
                })}
                errors={errors}
              />
            </label>
          </div>
          <div className="mb-3">
            <label className="block">
              <OInputField
                wrapperClassName="relative z-0   w-full group"
                name="nameAr"
                inputLabel={<>Name (Arbic)</>}
                type="text"
                register={register("nameAr", {
                  required: "Please enter name (arbic)",
                })}
                errors={errors}
              />
            </label>
          </div>

</div>

        

<div className="grid grid-rows-1 grid-cols-1 gap-4">
            <h4 className="text-lg font-semibold py-3">
              Icon
            </h4>
            <div className="photo_list flex flex-wrap gap-5">
            <div
                className='p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer'
                onClick={() => iconRef?.current?.click()}
              >
                <div className='text-center'>
                  <img
                    src='../images/uploadimg.png'
                    className='m-auto'
                    alt=''
                  />
                  <strong className='my-2 block text-xl'>
                    {t('ADD_PHOTO')}
                  </strong>                
                  <input
                    type="file"
                    accept='image/png, image/jpg, image/jpeg'
                    name='icon'
                    ref={iconRef}
                    onChange={(e) => handlePhotosChange(e)}
                    className='hidden'
                  />
                </div>
              </div>

              {icon?.length > 0 && (
                <div
                  style={{ cursor: "move" }}
                  className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                >
                  <figure className="w-full h-full">
                    <OImage
                      src={
                        typeof icon === "object"
                          ? URL.createObjectURL(icon[0])
                          : icon
                      }
                      fallbackUrl="/images/user.png"
                      className="w-full h-full object-cover"
                      alt=""
                    />
                  </figure>

                  <button
                    type="button"
                    className="absolute top-[10px] right-[10px]"
                    onClick={() =>
                      setIcon()
                    }
                  >
                    <img src={photoClose} alt="" />
                  </button>
                </div>
              )}
            </div>
          </div>
      

        <div className="border-t mt-10 py-10 text-center">
          <button className="bg-lime-500 hover:bg-[#8FC150] cursor-pointer   text-white  font-normal active:bg-slate-100 text-md px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150">
            {t("SAVE")}
          </button>
        </div>
      </div>
    </form>
  </div>
  );
};

export default EditProjectStatus;
